import {createAction} from '@reduxjs/toolkit';

export const setOptionShippingMethod = createAction('CHECKOUT@SET_OPTION_SHIPPING_METHOD');

export const setOptionPaymentMethod = createAction('CHECKOUT@SET_OPTION_PAYMENT_METHOD');
